export default __webpack_public_path__ + "static/media/logo-white.2992bf1f.png";